// extracted by mini-css-extract-plugin
export var sliderRange = "_nm-2";
export var sliderRoot = "_nm-0";
export var sliderThumb = "_nm-3";
export var sliderTrack = "_nm-1";